<template>
  <div class="w-100 mt-1 small d-flex flex-column">
    <card class="d-flex flex-column" v-if="showIsKeys(condicao, ['genero', 'nacionalidade', 'estadoCivil', 'profissao', 'inscricaoEstadual'])"
          titulo="Dados Básicos">
      <div class="w-100 mt-1 d-flex flex-column">
        <span v-if="item.genero"><strong>Sexo: </strong> {{ nomearItem(item.genero, sexo) }}</span>
        <span v-if="item.nacionalidade"><strong>Nacionalidade: </strong> {{nomearItem(item.nacionalidade, nacionalidade)}}</span>
        <span v-if="item.estadoCivil"><strong>Estado civil: </strong> {{nomearItem(item.estadoCivil, estadoCivil)}}</span>
        <span v-if="item.profissao"><strong>Profissão: </strong> {{ item.profissao }}</span>
        <span v-if="item.estadoCivil && item.estadoCivil !== 'CASADO'"><strong>União Estável: </strong> {{item.uniaoEstavel ? 'Sim' : 'Não'}}</span>
        <span v-if="item.inscricaoEstadual"><strong>Inscrição estadual: </strong> {{item.inscricaoEstadual}}</span>
      </div>
    </card>
    <card class="d-flex flex-column" v-if="showIsKeys(condicao, ['rg'])"
          titulo="Identificação">
      <div class="w-100 mt-1 d-flex flex-column">
        <span v-if="item.rg"><strong>RG: </strong> {{item.rg}}</span>
      </div>
    </card>
    <card class="d-flex flex-column" v-if="showIsKeys(condicao, ['nomeConjuge','cpfConjuge','dataCasamento','regimeBens','casamentoAposLei6515','nomeExConjuge','cpfExConjuge','dataSeparacao','dataExtincaoConjugal'])"
          :titulo="`Dados ${tituloConsorcio()}`">
      <div class="w-100 mt-1 d-flex flex-column">
        <span v-if="item.nomeConjuge"><strong>Cônjuge: </strong> {{item.nomeConjuge}}</span>
        <span v-if="item.cpfConjuge"><strong>CPF Cônjuge: </strong> {{item.cpfConjuge}}</span>
        <span v-if="item.nomeExConjuge"><strong>Ex-Cônjuge: </strong> {{item.nomeExConjuge}}</span>
        <span v-if="item.cpfExConjuge"><strong>CPF Ex-Cônjuge: </strong> {{item.cpfExConjuge}}</span>
        <span v-if="item.dataCasamento"><strong>Data do Casamento: </strong> {{item.dataCasamento}}</span>
        <span v-if="item.casamentoAposLei6515 != null"><strong>Após Lei 6.515: </strong> {{item.casamentoAposLei6515 ? 'Sim' : 'Não'}}</span>
        <span v-if="item.regimeBens"><strong>Regime: </strong> {{nomearItem(item.regimeBens || item.regime, regime)}}</span>
        <span v-if="item.dataSeparacao"><strong>Data da Separação: </strong> {{item.dataSeparacao}}</span>
        <span v-if="item.dataExtincaoConjugal"><strong>Data da Extinção Conjugal: </strong> {{item.dataExtincaoConjugal}}</span>
      </div>
    </card>
    <card class="d-flex flex-column" v-if="showIsKeys(condicao, ['email', 'telefone'])"
          titulo="Contato">
      <div class="w-100 mt-1 d-flex flex-column">
        <span v-if="item.email"><strong>E-mail: </strong> {{ item.email }}</span>
        <span v-if="item.telefone"><strong>RG: </strong> {{item.telefone}}</span>
      </div>
    </card>
    <card v-if="showIsKeys(condicao, ['cep', 'tipoLogradouro', 'logradouro', 'numero', 'bairro', 'cidade', 'uf'])"
          titulo="Endereço">
      <div class="w-100 mt-1 d-flex flex-column">
        <span v-if="item.cep"><strong>CEP: </strong> {{ item.cep }}</span>
<!--        <span v-if="item.tipoLogradouro"><strong>Tipo Logradouro: </strong> {{item.tipoLogradouro}}</span>-->
        <span v-if="item.logradouro"><strong>Logradouro: </strong> {{item.logradouro}}</span>
        <span v-if="item.numero"><strong>Número: </strong> {{item.numero}}</span>
        <!-- <span v-if="item.unidade"><strong>Unidade: </strong> {{item.unidade}}</span>-->
        <span v-if="item.bairro"><strong>Bairro: </strong> {{item.bairro}}</span>
        <span v-if="item.cidade"><strong>Cidade: </strong> {{item.cidade}}</span>
        <span v-if="item.uf"><strong>Estado: </strong> {{item.uf}}</span>
      </div>
    </card>
    <card class="d-flex flex-column" v-if="showIsKeys(condicao, ['representanteNome', 'representanteCpf'])"
          titulo="Representante">
      <div class="w-100 mt-1 d-flex flex-column">
        <span v-if="item.representanteNome"><strong>Nome: </strong> {{ item.representanteNome }}</span>
        <span v-if="item.representanteCpf"><strong>CPF: </strong> {{item.representanteCpf}}</span>
      </div>
    </card>
  </div>
</template>

<script setup>

import Card from '@/components/Layout/components/Card.vue';
import FrontBusiness from "@/business/FrontBusiness";
import IndicadorPessoalBusiness from "@/business/indicadores/IndicadorPessoalBusiness";

const props = defineProps({
  condicao: Object,
  item: Object,
});


const regime = IndicadorPessoalBusiness.getRegimes()
const nacionalidade = IndicadorPessoalBusiness.getNacionalidades()
const estadoCivil = IndicadorPessoalBusiness.getEstadosCivil()
const sexo = IndicadorPessoalBusiness.getSexos()


const tituloConsorcio = () => {
  const ec = props.item?.estadoCivil;
  if (ec === 'DIVORCIADO') return 'Divórcio';
  if (ec === 'SEPARADO' || ec === 'SEPARADO_JUDICIALMENTE') return 'Separação';
  if (ec === 'VIUVO') return 'Viuvez';
  if (props.item?.uniaoEstavel && ec !== 'CASADO') return 'União Estável';
  return 'Casamento';
}

const nomearItem = FrontBusiness.getLabel

const showIsKeys = (data, keys) => {
  return (keys.filter(e => data?.[e])).length
}
</script>
